export const isAuthenticated = (state) => {
    if (state.auth.auth.idToken) return true;
    // if(state.successMessage === "Login Successfully Completed") return true;
    return false;
};
